<zbp-modal-template
  [modalHeader]="scoreDetailsModalHeader"
  [bodyContent]="scoreDetailsModalBody"
  [footerContent]="scoreDetailsModalFooter"
  [isScrollable]="true"
>
  <ng-template #scoreDetailsModalHeader>
    <div class="d-flex flex-row justify-content-between w-100 align-items-center" id="scoreDetailsModalHeader">
      <h1 class="modal-template-header-text h2">{{'shared-score-detail-header' | translate }}</h1>
      <div class="button-wrapper">
        @if(allowEdit && !!parts && editableStatuses.includes(assessmentStatus)) {
          <zbp-button-component
            theme="icon"
            [iconName]="zbpIconNames.pencil"
            (clickHandler)="enableEditMode()"
            type="button"
            [showSpinner]="isSaving"
            [disabled]="isEditing"
            class="text-uppercase"
            [ariaLabel]="'shared-score-detail-label-edit' | translate">
          </zbp-button-component>
        }
        <zbp-button-component
          theme="icon"
          [iconName]="zbpIconNames.printer"
          [showSpinner]="isSaving"
          (clickHandler)="print()"
          type="button"
          [ariaLabel]="'shared-score-detail-label-print' | translate">
        </zbp-button-component>
      </div>
    </div>
  </ng-template>
  <ng-template #scoreDetailsModalBody>
    <div
      id="groupModalContainer"
      class="modal-template"
      [cdkTrapFocus]="isEditing"
      [cdkTrapFocusAutoCapture]="isEditing"
    >
      <zbp-score-detail-view
        [studentName]="studentName"
        [className]="className"
        [productName]="productName"
        [activityName]="activityName"
        [columns]="columns"
        [rows]="rows"
        [printableHeaders]="printableHeaders"
        [showSpinner]="isLoading"
      />
    </div>
  </ng-template>

  <ng-template #scoreDetailsModalFooter>
    <div class="button-wrapper">
      <zbp-button-component
        theme="ghostFocus"
        [label]="'shared-button-close' | translate"
        (click)="dismiss()"
        type="button"
        [disabled]="isSaving"
        class="text-uppercase">
      </zbp-button-component>
      <zbp-button-component
        *ngIf="!!parts && (isEditing || hasUnscoredManualSection)"
        theme="primary"
        [label]="'shared-button-save' | translate"
        (click)="save()"
        type="button"
        [disabled]="addSubFormControls.pristine || isSaving"
        class="text-uppercase score-detail-save-button">
      </zbp-button-component>
    </div>
  </ng-template>
</zbp-modal-template>
